/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'baglass/core-client/js/core-client/ui/core/View',
	'text!./templates/StoryPaneView.html',
	'./FilmStripView',
	'../nls/StringResources',
	'../lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/catalog_32'
], function(View, Template, FilmStripView, stringResources, svgStoryCatalog) {

	const StoryPaneView = View.extend({

		templateString: Template,

		init: function(options) {
			StoryPaneView.inherited('init', this, arguments);

			this.dashboardApi = options.dashboardApi;
			this.services = options.services;

			this.minimumSize = 200;
		},

		initialize: function () {
			return this._setupEvents();
		},

		_setupEvents: function () {
			return this.dashboardApi.getDashboardSvc('.LifeCycleManager').then(LifeCycleManager => {
				LifeCycleManager.registerLifeCycleHandler('post:dashboard.focus', () => {
					if (this.dashboardApi.getCurrentContentView().isAuthorMode()) {
						this.trigger('openPane');
					}
				});

				LifeCycleManager.registerLifeCycleHandler('post:mode.edit', () => {
					this.trigger('openPane');
				});
			});
		},

		getSplitterOpts: function () {
			return Promise.resolve({
				handleClass: 'storyHandle',
				handleIcon: svgStoryCatalog.default.id,
				handleOpenTitle: stringResources.get('filmstripHandleOpenLabel'),
				handleCloseTitle: stringResources.get('filmstripHandleCloseLabel'),
				hidden: false,
				view: this,
				initialSize: 200,
				overrideGlobalMaxSize: 200
			});
		},

		/**
		 * Renders the StoryPaneView and eventually renders the FilmStripView inside it.
		 *
		 * @returns Promise
		 */
		render: function() {
			const sHtml = this.dotTemplate();
			this.$el
				// the 'blockOnExpandView' class is used when widgets are expanded (in 'focus mode')
				.addClass('storytelling blockOnExpandView')
				.html(sHtml);

			// Add the first view.
			return this._createFilmStrip();

		},

		remove: function() {
			if(this.filmStripView) {
				this.filmStripView.remove();
			}
			StoryPaneView.inherited('remove', this, arguments);
		},

		_createFilmStrip: function() {
			const blankNode = document.createElement('div');
			this.el.querySelector('.content').appendChild(blankNode);

			return Promise.all([
				this.dashboardApi.getDashboardSvc('.DndManager'),
				this.dashboardApi.getDashboardSvc('.StoryPaneService')
			]).then(([dndManager, storyPaneController ]) => {
				this.filmStripView = new FilmStripView({
					el: blankNode,
					dashboardApi: this.dashboardApi,

					controller: storyPaneController,
					dndManager: dndManager,

					glassContext: this.services.biGlass.glassContext,
					services: this.services
				});
				return this.filmStripView.render();
			});
		}
	});

	return StoryPaneView;
});
